import React, { Component } from 'react';
import Mark from 'mark.js';

import './Preview.scss';

class Preview extends Component {

	constructor(props) {
		super(props);

		this.titleSampleRef = React.createRef();
		this.descrSampleRef = React.createRef();
		this.desktopTitleRef = React.createRef();
		this.mobileTitleRef = React.createRef();

		this.state = {
			title: '',
			titleMobile: '',
		}
	}

	isTitleTooLong() {
		const titleSample = this.titleSampleRef.current;
		if (!titleSample) {
			return false;
		}
		let textWidth = titleSample.clientWidth;
		return textWidth > 580;
	}

	shortenTitle() {
		var shortened = false;
		const titleSample = this.titleSampleRef.current;
		if (!titleSample) {
			return this.props.title;
		}
		titleSample.textContent = this.props.title;
		while (this.isTitleTooLong()) {
			var title = titleSample.textContent;
			if (!title) {
				break;
			}
			title = title.replace(/\/$/, ' ...');
			title = title?.split(' ')?.slice(0, -1)?.join(' ');
			title = title.replace(/,\s*$/, "");
			shortened = true;
			titleSample.textContent = title;
		}
		let finalTitle = titleSample.textContent;
		if (shortened) {
			finalTitle += ' ...';
		}

		return finalTitle;
	}

	prepareDescription(text, maxWidth, maxLength = 0) {
		const words = text?.split(' ');
		const sample = this.descrSampleRef.current;
		if (!sample) {
			return text;
		}
		text = this.truncateText(text, maxLength);
		sample.textContent = text;
		var cut = false;
		while (sample.clientWidth > maxWidth) {
			words.pop();
			cut = true;
			var newText = words.join(' ');
			sample.textContent = newText;
		}

		return cut ? words.join(' ') + ' ...' : text;
	}

	truncateText(text, limit) {
		let output = '';
		const words = text.split(' ');
		let oldOutput = '';

		for (var i = 0; i < words.length; i++) {
			oldOutput = output;
			output += ' ' + words[i];
			if (output.length > limit) {
				output = oldOutput + ' ...';
				break;
			}
		}

		output = output.replace(/,\s*$/, "");

		return output;
	}

	splitUrl(string) {
		let url;
		try {
			url = new URL(string);
		} catch (_) {
			return false;
		}
		let {hostname, pathname} = url;

		return {
			domain: hostname,
			path: pathname !== '/' ? pathname.replace(new RegExp('/', 'g'), ' › ') : '',
		}
	}

	boldKeywords(text) {
		if (!this.props.keywords) {
			return text;
		}
		let keywords = this.props.keywords.split(',');
		keywords = keywords.map((word) => word.trim());

		const el = document.createElement('div');
		el.textContent = text;

		let instance = new Mark(el);
		instance.mark(keywords, {
			separateWordSearch: false,
		});

		return el.innerHTML;
	}

	render() {
		let descr = this.props.date ? 'Oct 10, 2022 - ' + this.props.descr : this.props.descr;

		let description = this.prepareDescription(descr, 960, 158);
		description = this.boldKeywords(description);
		let mobileDescription = this.prepareDescription(descr, 680, 158);
		mobileDescription = this.boldKeywords(mobileDescription);
		let url = this.splitUrl(this.props.url);
		let title = this.shortenTitle();

		let ratingDesktop = '';
		let ratingMobile = '';
		if (this.props.rating) {
			ratingDesktop = (
				<div className="search-result-rating">
					<span className="rating-stars"><span className="rating-stars-bright"></span></span>
					<span className="rating-value">{window?.t?.LABEL_RATING}: 4</span> · <span className="rating-votes">115 {window?.t?.VOTES}</span>
				</div>
			);
			ratingMobile = (
				<div className="search-result-rating">
					<span className="rating-value">4,0</span> <span className="rating-stars"><span className="rating-stars-bright"></span></span> <span className="rating-votes">(115)</span>
				</div>
			);
		}

		if (this.props.date) {
			description = description.replace('Oct 10, 2022', '<span class="result-date">Oct 10, 2022</span>');
			mobileDescription = mobileDescription.replace('Oct 10, 2022', '<span class="result-date">Oct 10, 2022</span>');
		}

		return (
			<div className="serp-preview">
				<div className="sample title" ref={this.titleSampleRef}></div>
				<div className="sample descr" ref={this.descrSampleRef}></div>

				<h4>{window?.t?.DESKTOP}</h4>
				<div className="search-result desktop">
					<div className="search-result-url"><span className="domain">{url.domain}</span>{url.path}</div>
					<div className="search-result-title"><a href={this.props.url} ref={this.desktopTitleRef}>{title}</a></div>
					<div className="search-result-descr" dangerouslySetInnerHTML={{__html: description}}></div>
					{ratingDesktop}
				</div>
				<h4>{window?.t?.MOBILE}</h4>
				<div className="search-result mobile">
					<div className="search-result-url"><span className="domain">{url.domain}</span>{url.path}</div>
					<div className="search-result-title"><a href={this.props.url} ref={this.mobileTitleRef}>{title}</a></div>
					<div className="search-result-descr" dangerouslySetInnerHTML={{__html: mobileDescription}}></div>
					{ratingMobile}
				</div>

				<div className="form-field checkbox">
					<input type="checkbox" id="rating" value="1" onChange={event => this.props.changeCallback('rating', !this.props.rating)} />
					<label htmlFor="rating">{window?.t?.LABEL_RATING}</label>

					<input type="checkbox" id="date" value="1" onChange={event => this.props.changeCallback('date', !this.props.date)} />
					<label htmlFor="date">{window?.t?.LABEL_DATE}</label>
				</div>
			</div>
		);
	}
}

export default Preview;